import { render, staticRenderFns } from "./IndexReport.vue?vue&type=template&id=35a0387a"
import script from "./IndexReport.vue?vue&type=script&lang=js"
export * from "./IndexReport.vue?vue&type=script&lang=js"
import style0 from "./IndexReport.vue?vue&type=style&index=0&id=35a0387a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports